import { useState } from 'react';

/**
 * Styled tooltip whose UI is fetched the first time someone actually reaches
 * for the trigger. The tooltip package only ever runs on hover, so importing it
 * up front would put it in every visitor's initial bundle for a label most of
 * them never see. Until it has loaded, the trigger renders as plain content —
 * same markup, no visual difference — and the tooltip opens as soon as the
 * package arrives, so hovering works on the first try.
 */
export default function LazyTooltip({ label, children }) {
  const [tooltipUi, setTooltipUi] = useState(null);
  const [triggerReached, setTriggerReached] = useState(false);

  const load = () => {
    setTriggerReached(true);
    if (!tooltipUi) import('@/components/ui/tooltip').then((module) => setTooltipUi(() => module));
  };

  const release = () => setTriggerReached(false);

  if (!tooltipUi) {
    return (
      <span onMouseEnter={load} onMouseLeave={release} onFocus={load} onBlur={release}>
        {children}
      </span>
    );
  }

  const { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } = tooltipUi;

  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip defaultOpen={triggerReached}>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent>{label}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}